import React from "react";
import "./Privacy.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Privacy() {
  const brand = {
    name: "SIAM TRAVEL",
    address:
      "181 Phạm Ngũ Lão, Quận 1, Thành phố Hồ Chí Minh, 700000, Việt Nam",
    website: "https://www.rutthetindunghanoi.online",
    phone: "(+84) 941 297 219",
    email: "raumuongluoc171@gmail.com",
    industry: "tour du lịch",
    updatedAt: "27/12/2025",
  };

  return (
    <main className="pp-wrap">
      <Navbar />
      <div className="pp-container">
        <header className="pp-hero">
          <h1 className="pp-title">Chính sách bảo mật</h1>
          <p className="pp-sub">
            Tài liệu này mô tả cách {brand.name} thu thập, sử dụng và bảo vệ
            thông tin cá nhân của khách hàng khi sử dụng dịch vụ{" "}
            {brand.industry}.
          </p>

          <div className="pp-card">
            <div className="pp-row">
              <span className="pp-label">Đơn vị:</span>
              <span className="pp-value">{brand.name}</span>
            </div>
            <div className="pp-row">
              <span className="pp-label">Địa chỉ:</span>
              <span className="pp-value">{brand.address}</span>
            </div>
            <div className="pp-row">
              <span className="pp-label">Trang web:</span>
              <a
                className="pp-link"
                href={`https://${brand.website}`}
                target="_blank"
                rel="noreferrer"
              >
                {brand.website}
              </a>
            </div>
            <div className="pp-row">
              <span className="pp-label">Điện thoại:</span>
              <a
                className="pp-link"
                href={`tel:${brand.phone.replace(/[^\d+]/g, "")}`}
              >
                {brand.phone}
              </a>
            </div>
            <div className="pp-row">
              <span className="pp-label">Email:</span>
              <a className="pp-link" href={`mailto:${brand.email}`}>
                {brand.email}
              </a>
            </div>
            <div className="pp-row">
              <span className="pp-label">Cập nhật:</span>
              <span className="pp-value">{brand.updatedAt}</span>
            </div>
          </div>
        </header>

        <section className="pp-section">
          <h2>1. Phạm vi áp dụng</h2>
          <p>
            Chính sách này áp dụng cho khách hàng truy cập website{" "}
            {brand.website} hoặc liên hệ với {brand.name}
            để tư vấn, đặt tour, đăng ký dịch vụ, yêu cầu hỗ trợ, hoặc tham gia
            các hoạt động liên quan.
          </p>
        </section>

        <section className="pp-section">
          <h2>2. Thông tin chúng tôi có thể thu thập</h2>
          <ul>
            <li>
              <b>Thông tin nhận dạng:</b> họ tên, số điện thoại, email, địa chỉ
              (nếu cần để xuất hóa đơn hoặc xác nhận).
            </li>
            <li>
              <b>Thông tin đặt dịch vụ:</b> tour quan tâm, ngày đi, số lượng
              khách, yêu cầu đặc biệt (ăn kiêng, người cao tuổi, trẻ em… nếu
              khách cung cấp).
            </li>
            <li>
              <b>Thông tin thanh toán:</b> trạng thái thanh toán/biên nhận
              (không khuyến khích gửi thông tin nhạy cảm qua chat).
            </li>
            <li>
              <b>Dữ liệu kỹ thuật:</b> địa chỉ IP, loại thiết bị/trình duyệt,
              cookie, trang đã xem (nhằm cải thiện trải nghiệm).
            </li>
          </ul>
        </section>

        <section className="pp-section">
          <h2>3. Mục đích sử dụng thông tin</h2>
          <ul>
            <li>
              Tư vấn tour, báo giá, xác nhận lịch trình và hỗ trợ khách hàng.
            </li>
            <li>
              Xử lý yêu cầu đặt tour/dịch vụ, chăm sóc trước – trong – sau
              chuyến đi.
            </li>
            <li>
              Cải thiện chất lượng website, tối ưu nội dung và trải nghiệm người
              dùng.
            </li>
            <li>
              Gửi thông báo liên quan đến dịch vụ (xác nhận đặt chỗ, thay đổi
              lịch, khuyến mãi nếu khách đồng ý).
            </li>
            <li>
              Phòng chống gian lận, bảo vệ an toàn hệ thống và tuân thủ yêu cầu
              pháp luật (nếu có).
            </li>
          </ul>
        </section>

        <section className="pp-section">
          <h2>4. Cookie & công nghệ theo dõi</h2>
          <p>
            Website có thể sử dụng cookie hoặc công cụ phân tích để ghi nhận
            hành vi truy cập (ví dụ: số lần xem trang, thời gian ở lại, thiết
            bị). Bạn có thể tắt cookie trong trình duyệt, tuy nhiên một số tính
            năng có thể hoạt động không tối ưu.
          </p>
        </section>

        <section className="pp-section">
          <h2>5. Chia sẻ thông tin với bên thứ ba</h2>
          <p>
            {brand.name} <b>không bán</b> thông tin cá nhân của khách hàng.
            Chúng tôi chỉ chia sẻ khi cần thiết để cung cấp dịch vụ, ví dụ:
          </p>
          <ul>
            <li>
              Đối tác vận chuyển, lưu trú, hướng dẫn viên, nhà cung cấp dịch vụ
              tour (trong phạm vi phục vụ chuyến đi).
            </li>
            <li>
              Đơn vị hỗ trợ kỹ thuật/website/đo lường hiệu quả (theo hợp đồng
              bảo mật).
            </li>
            <li>
              Cơ quan có thẩm quyền khi có yêu cầu hợp pháp theo quy định.
            </li>
          </ul>
        </section>

        <section className="pp-section">
          <h2>6. Thời gian lưu trữ</h2>
          <p>
            Thông tin được lưu trữ trong thời gian cần thiết để hoàn thành mục
            đích dịch vụ hoặc theo yêu cầu pháp luật. Khi không còn cần thiết,
            chúng tôi sẽ xóa hoặc ẩn danh dữ liệu theo quy trình nội bộ.
          </p>
        </section>

        <section className="pp-section">
          <h2>7. Bảo mật thông tin</h2>
          <ul>
            <li>
              Giới hạn quyền truy cập dữ liệu trong nội bộ theo vai trò công
              việc.
            </li>
            <li>
              Áp dụng các biện pháp kỹ thuật hợp lý để chống truy cập trái phép,
              thất thoát dữ liệu.
            </li>
            <li>
              Khuyến nghị khách hàng không gửi thông tin nhạy cảm qua kênh công
              khai/không an toàn.
            </li>
          </ul>
        </section>

        <section className="pp-section">
          <h2>8. Quyền của khách hàng</h2>
          <ul>
            <li>Yêu cầu xem, chỉnh sửa hoặc cập nhật thông tin cá nhân.</li>
            <li>Yêu cầu ngừng nhận thông tin marketing (nếu có).</li>
            <li>Yêu cầu xóa dữ liệu trong phạm vi pháp luật cho phép.</li>
          </ul>
          <p>
            Để thực hiện các quyền trên, vui lòng liên hệ theo thông tin ở mục
            “Liên hệ”.
          </p>
        </section>

        <section className="pp-section">
          <h2>9. Liên hệ</h2>
          <div className="pp-contact">
            <div>
              <b>{brand.name}</b>
            </div>
            <div>Địa chỉ: {brand.address}</div>
            <div>
              Website:{" "}
              <a
                className="pp-link"
                href={`https://${brand.website}`}
                target="_blank"
                rel="noreferrer"
              >
                {brand.website}
              </a>
            </div>
            <div>
              Điện thoại:{" "}
              <a
                className="pp-link"
                href={`tel:${brand.phone.replace(/[^\d+]/g, "")}`}
              >
                {brand.phone}
              </a>
            </div>
            <div>
              Email:{" "}
              <a className="pp-link" href={`mailto:${brand.email}`}>
                {brand.email}
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </main>
  );
}
